const workPageAnimation = () => {
  const title = document.querySelector(".works-container .works-title");

  if (title) {
    gsap.set(title, {
      x: -700,
    });

    gsap.to(title, {
      x: 0,
      duration: 1.5,
      ease: "back.out(1.2)",
    });
  }
};

export default workPageAnimation;
